export default "__VITE_ASSET__CMf01VTA__"